import type {
    ComponentChildren,
    JSX,
} from "preact";
import {
    forwardRef,
} from "preact/compat";

type BadgeVariant = "default" | "success" | "warning" | "error";

type BadgeProps = JSX.HTMLAttributes<HTMLSpanElement> & {
    variant?: BadgeVariant;
    children: ComponentChildren;
};

const variantStyles: Record<BadgeVariant, string> = {
    default: "bg-bg-tertiary text-text-secondary",
    success: "bg-success/20 text-success",
    warning: "bg-warning/20 text-warning",
    error: "bg-error/20 text-error",
};

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
    ({
        variant = "default",
        className = "",
        children,
        ...props
    }, ref) => {
        return (
            <span
                ref={ref}
                className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${
                    variantStyles[variant]
                } ${className}`}
                {...props}
            >
                {children}
            </span>
        );
    },
);
